import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {PropertyEditModule} from '@aztrix/components/property-edit';
import {HelperPipesModule} from '@aztrix/helpers';
import {IconsModule} from '@aztrix/icons';
import {TranslatePipe} from '@aztrix/translate';

import {ProposalVerificationFormComponent} from './proposal-verification-form.component';

@NgModule({
  declarations: [ProposalVerificationFormComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    IconsModule,
    PropertyEditModule,
    TranslatePipe,
    HelperPipesModule,
  ],
  exports: [ProposalVerificationFormComponent],
})
export class ProposalVerificationFormModule {}
